export default function parseContentDisposition(
    header: string | undefined | null,
): string | null {
    if (!header) return null

    const extendedMatch = header.match(
        /(?:^|;)\s*filename\*\s*=\s*UTF-8''([^;]+)/i,
    )

    if (extendedMatch) {
        try {
            return decodeURIComponent(extendedMatch[1].trim()) || null
        } catch {
            return null
        }
    }

    const basicMatch = header.match(
        /(?:^|;)\s*filename\s*=\s*(?:"([^"]+)"|([^";]+))/i,
    )

    return (basicMatch?.[1] ?? basicMatch?.[2])?.trim() || null
}
